var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casechart",attrs:{"data-test-id":"DailyCasesChartContainerComponent"}},[_c('DailyCasesChart',{attrs:{"labels":_vm.labels,"chart-data":_vm.chartData,"styles":{ height: '250px', position: 'relative' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }